import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === '147256kb') {
      sessionStorage.setItem('admin_auth', '1');
      navigate('/admin/dashboard');
    } else {
      setError('密碼錯誤，請再試一次');
    }
  };

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="https://static.readdy.ai/image/15419bedb578ec59343dd2ae27ec91d5/bcd8c2dce83612dc3328f52b56b1caf2.png"
            alt="Logo"
            className="h-14 w-auto object-contain mx-auto mb-6"
            style={{ filter: 'drop-shadow(0 0 8px rgba(255,255,255,0.2))' }}
          />
          <h1 className="text-2xl font-bold text-white mb-1">後台管理系統</h1>
          <p className="text-gray-400 text-sm">請輸入管理員密碼登入</p>
        </div>

        <div className="bg-gray-800 rounded-2xl p-8">
          <form onSubmit={handleLogin}>
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-300 mb-2">管理員密碼</label>
              <input
                type="password"
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(''); }}
                placeholder="請輸入密碼"
                className="w-full bg-gray-700 border border-gray-600 text-white placeholder-gray-400 rounded-xl px-4 py-3 text-sm outline-none focus:border-orange-400 transition-colors"
              />
              {error && <p className="text-red-400 text-xs mt-2">{error}</p>}
              <p className="text-gray-500 text-xs mt-2">預設密碼：admin123（建議修改）</p>
            </div>
            <button
              type="submit"
              className="w-full py-3.5 bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-xl transition-colors cursor-pointer whitespace-nowrap"
            >
              登入後台
            </button>
          </form>
        </div>

        <div className="text-center mt-6">
          <button onClick={() => navigate('/')} className="text-gray-500 hover:text-gray-300 text-sm cursor-pointer">
            ← 返回前台網站
          </button>
        </div>
      </div>
    </div>
  );
}
